<template>
  <div>
    <a-select
      :value="value"
      allow-clear
      show-search
      :multiple="false"
      :placeholder="placeholder"
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
      :disabled="isEdit"
      :virtual="false"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="`${item.id}`"
        :value="`${item.id}`"
        :title="item.name"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, watch, onActivated } from "vue";
import { ApplyService } from "@/views/purchase/apply/apply.service";
import { useRoute } from "vue-router";

/**
 * 采购申请选择器
 */
export default defineComponent({
  name: "PurchaseApplySelect",
  props: {
    placeholder: { type: String, default: "请选择" },
    isEdit: {
      type: Boolean,
      default: false,
    },
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
    value: { type: String, default: undefined },
    url: { type: String, default: undefined },
    validStatus: { type: Array, default: [] },
  },
  emits: ["update:value", "change", "clear", "selectChange"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = ApplyService.useSimpleListApi();
    const route = useRoute();
    const onChange = (id) => {
      emit("update:value", id);
      emit("change", id);
      emit("selectChange", id);
    };

    const onClear = () => {
      emit("update:value", "");
      emit("clear", "");
    };
    const initData =async () => {
      const params = {};
      if (props.validStatus && _.isArray(props.validStatus)) {
        params["validStatus"] = props.validStatus.join("");
      }
      if(props.addRightBizType){
        params["addRightBizType"] = props.addRightBizType
      }
      if(route['query']['projectId']){ // 优先展示该项目下的数据
        params['firstDisplayProjectId']=route['query']['projectId'];
      }
      await run(params,props.url);
      if (props.externalData.purchaseApplyId && props.externalData.purchaseApplyName) {
        data.value?.records && (data.value?.records as any).push({ id: props?.externalData?.purchaseApplyId, name: props?.externalData?.purchaseApplyName });
      }
     
    };
    onMounted(async () => {
      await initData();
    });
    onActivated(async () => {
      await  initData();
    });
    watch(
      () => props.value,
      (id, o) => {
        emit("update:value", id);
        emit("change", id);
      },
      { immediate: true }
    );

    return {
      data,
      loading,
      onChange,
      onClear,
    };
  },
});
</script>
